import React from 'react';
export function CommunityTestimonials() {
  const socialMediaPosts = ['https://uploadthingy.s3.us-west-1.amazonaws.com/6GufbDgSiG3Kjh3qp9GL4M/Screenshot_2025-10-14_at_16.23.44.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/eMkHv6A72GcA241aDq26dQ/Screenshot_2025-10-14_at_16.24.17.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qowXcWmmS5cPEHGFicWs8h/Screenshot_2025-10-14_at_16.24.28.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/x8PJNuhgKaALH34vvHAHXz/Screenshot_2025-10-14_at_16.25.11.png'];
  return <section className="py-16 bg-white" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-medium py-1 px-3 rounded-full mb-3" data-id="element-23">
            Community
          </span>
          <h3 className="text-4xl font-bold text-gray-800" data-id="element-24">
            Erfahrungsberichte aus der eve nutrition Community
          </h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-25">
          {socialMediaPosts.map((imageUrl, index) => <div key={index} className="rounded-lg h-40 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-26">
              <img src={imageUrl} alt={`Eve nutrition Social Media Post ${index + 1}`} className="w-full h-full object-cover" data-id="element-27" />
            </div>)}
        </div>
        <p className="text-gray-600 mt-4 text-center" data-id="element-28">
          Authentische Bewertungen und Produktempfehlungen von Instagram und
          Facebook
        </p>
      </div>
    </section>;
}